import React, { useState, useEffect, Fragment } from 'react'
import styled from 'styled-components'
import CreateInput from '../../components/input'
import { Alert } from '@material-ui/lab'
import { Fade, Button } from '@material-ui/core'
import propTypes, { string } from 'prop-types'
import { Delete } from '@material-ui/icons'
import JoditEditor from 'jodit-react'

const Specificdata = (props) => {
  const [steps, setStep] = useState(props.process || [])

  const handleAdd = () => setStep([...steps, ''])

  const handleChange = target => {
    const currentStep = target.name
    const currentData = [...steps]
    currentData[currentStep] = target.value
    setStep(currentData)
  }

  const handleDescriptionChange = value => {
    if (typeof value === 'object' && value.target && value.target.innerHTML) {
      return props.handleChange({ name: 'description', value: value.target.innerHTML })
    }
    props.handleChange({ name: 'description', value })
  }

  const handleIndicationsChange = value => {
    if (typeof value === 'object' && value.target && value.target.innerHTML) {
      return props.handleChange({ name: 'indications', value: value.target.innerHTML })
    }
    props.handleChange({ name: 'indications', value })
  }

  const handleDelete = indexToDelete => {
    const newData = steps.filter((_data, index) => indexToDelete !== index)
    setStep(newData)
  }

  // sync global state with local State
  useEffect(() => {
    props.handleChange({ name: 'process', value: steps })
  }, [steps])

  if (props.currentStep !== 1) return null

  return (
    <Content>
      <Fade in={props.errors.length !== 0}>
        <GroupForm>
          <Alert severity='error'>Algunos campos son necesarios</Alert>
        </GroupForm>
      </Fade>

      <GroupForm>
        <Label>Descripción</Label>
        <div style={{ border: '1px solid var(--main-blue)', borderRadius: '5px', overflow: 'hidden' }}>
          <JoditEditor
            config={{ height: 200, askBeforePasteHTML: false }}
            onBlur={handleDescriptionChange}
            value={props.description || ''}
          />
        </div>
      </GroupForm>

      <GroupForm>
        <Label>Indicaciones</Label>
        <div style={{ border: '1px solid var(--main-blue)', borderRadius: '5px', overflow: 'hidden' }}>
          <JoditEditor
            config={{ height: 200, askBeforePasteHTML: false }}
            onBlur={handleIndicationsChange}
            value={props.indications || ''}
          />
        </div>
      </GroupForm>

      <GroupForm>
        <Label>Procedimiento</Label>
        {steps.map((value, index) => (
          <Fragment key={index}>
            <LabelSecondary>Paso {index + 1}</LabelSecondary>
            <div style={{ position: 'relative' }}>
              <TitleInput
                onChange={handleChange}
                type='textarea'
                name={index.toString()}
                rows={2}
                value={value || ''}
                {...props}
              />
              <DeleteStyled onClick={_event => handleDelete(index)} />
            </div>
          </Fragment>
        ))}

        <ButtonContainer>
          <ButtonStyled onClick={handleAdd} variant='contained' color='secondary'> Agregar paso </ButtonStyled>
        </ButtonContainer>
      </GroupForm>
    </Content>
  )
}

Specificdata.propTypes = {
  errors: propTypes.array,
  currentStep: propTypes.number,
  price: propTypes.number,
  handleChange: propTypes.func,
  process: propTypes.array,
  description: string,
  indications: string
}

const Content = styled('div')`
  max-width: 800px;
  margin: auto;
`
const GroupForm = styled('div')`
  margin: auto;
  margin-bottom: 20px;
  width: 80%;
  @media screen and (max-width: 500px) {
    width: 100%;
  }
`
const Label = styled('div')`
  color: var(--main-blue-dark);
  font-weight: bold;
  margin-bottom: 10px;
  font-size: 1.1em;
`
const TitleInput = styled(CreateInput)`
  width: 100%;
  .MuiTextField-root{
    color: red
  }
`
const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 15px;
`

const ButtonStyled = styled(Button)`
  min-width: 120px;
  margin-right: 20px;
  @media screen and (max-width:500px){
    &:last-of-type{
      margin-right: 0px;
    }
  }
`
const LabelSecondary = styled.div`
  color: var(--main-blue-dark);
  margin-top: 10px;
  font-weight: bold;
`
const DeleteStyled = styled(Delete)`
  position: absolute;
  top: 2px;
  right: 0;
  color: var(--main-blue);
  cursor: pointer;
`
export default Specificdata
